import { apiClient } from '@/lib/api/client'

/**
 * Agent tokens (BE-7) — a credential the artist mints for their own MCP client.
 *
 * The raw token is returned by `mint` and NEVER again: the server stores the `jti`, not
 * the token. There is nothing to hand back to someone who lost one, which is why the UI
 * has to make copying it feel important.
 */
export interface AgentToken {
  jti: string
  label: string | null
  expires_at: string
  last_used_at: string | null
  revoked_at: string | null
  created_at: string
}

export interface MintedToken {
  token: string
  jti: string
  label: string | null
  expiresAt: string
  notice: string
}

export const agentTokensApi = {
  list: async (): Promise<{ tokens: AgentToken[] }> => {
    const response = await apiClient.get('/api/v1/easel/agent-tokens')
    return response.data?.data ?? response.data
  },

  mint: async (label?: string): Promise<MintedToken> => {
    const response = await apiClient.post('/api/v1/easel/agent-tokens', { label })
    return response.data?.data ?? response.data
  },

  revoke: async (jti: string): Promise<{ revoked: boolean }> => {
    const response = await apiClient.delete(`/api/v1/easel/agent-tokens/${jti}`)
    return response.data?.data ?? response.data
  },
}
